export const quickAnswer =
  '本站不会伪造伤害数值。这里重点比较能力定位、操作方式和适合的玩法，帮助你在每个选择节点做决定。';

## 技能选择从玩法出发

先确定自己需要投射攻击、召唤支援、防御还是位置控制，再比较同组能力。一个适合你操作习惯的选择，比没有依据的“最强技能”标签更有用。

## 三组重点对比

第一组比较 Barrage、Volatile Anomaly 与 Shield；第二组比较 Ground Slam 与 Push；第三组比较 Ignite 与 Inferno。详情页说明适用情境、代价与重置方法。

## 记录完整搭配

用[配装规划器](/build-planner)保存五组选择，检查是否符合自己的战斗思路。网站选择不会替你解锁游戏技能。
